import { gql } from 'graphql-tag';

export default gql`
  query GetUserOpenCreditsTotal($input: GetUserCreditsTotalInput!) {
    getUserOpenCreditsTotal(input: $input)
  }
`;
